
import Vue from 'vue'
import HorarioAtual from '@/common/CurrentTime.vue'

  interface Data {
    sincronizandoPin: boolean
  }

  interface Methods {
    sincronizarUsuario(): void
  }

  interface Computed {
    estadoOperacao: boolean
    pinDoUsuario: string
    sincronizacaoWebFinalizada: boolean
  }

  interface Props {}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'Sincronizador',
  data: () => ({
    sincronizandoPin: false
  }),
  created () {
    this.$store.commit('sincronizador/resetState')
    this.$store.commit('marcacao/resetState')
  },
  mounted () {
    this.$store.dispatch('sincronizador/fazerSincronizacaoWeb')
  },
  computed: {
    estadoOperacao () {
      return this.sincronizandoPin || !this.sincronizacaoWebFinalizada
    },
    pinDoUsuario: {
      get () {
        return this.$store.state.sincronizador.pin
      },
      set (value: string) {
        this.$store.commit('sincronizador/atribuiPin', value)
      }
    },
    sincronizacaoWebFinalizada () {
      return this.$store.state.sincronizador.sincronizacaoWebFinalizada
    }
  },
  watch: {
    estadoOperacao (novoValor: boolean) {
      if (!novoValor) {
        this.$nextTick(() => {
          const inputPin = this.$refs.inputPin as HTMLInputElement
          if (inputPin) {
            inputPin.focus()
          }
        })
      }
    }
  },
  methods: {
    async sincronizarUsuario () {
      const regexApenasNumeros = /^\d+$/

      if (!this.pinDoUsuario) {
        const mensagemDeErroModalSemPin = this.$t('componentes.sincronizador.sincronizador.sincronizarUsuario.modalSemPin.texto') as string
        this.$swal({type: 'info', text: mensagemDeErroModalSemPin})
        return
      }

      if (!regexApenasNumeros.test(this.pinDoUsuario)) {
        const mensagemDeErroApenasNumeros = this.$t('componentes.sincronizador.sincronizador.sincronizarUsuario.modalPinInvalido.texto') as string
        this.$swal({type: 'info', text: mensagemDeErroApenasNumeros})
        return
      }

      this.sincronizandoPin = true
      const elementoParaFocarAposFecharModal = this.$refs.inputPin
      await this.$store.dispatch('sincronizador/fazerSincronizacaoUsuario', elementoParaFocarAposFecharModal)
      this.sincronizandoPin = false
    }
  },
  components: {HorarioAtual}
})
